import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

export default class HorizontalScrollingText {
    static init() {
        const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

        gsap.registerPlugin(ScrollTrigger);
    
        document.querySelectorAll('.horizontal-scrolling-text.desktop h2[data-gsap-scroll-right]').forEach((target) => {
            gsap.from(target, {
                x: -70,
                scrollTrigger: {
                    trigger: target,
                    start: 'top 600px',
                    end: 'bottom top',
                    markers: false,
                    pin: false,
                    pinSpacing: false,
                    scrub: 1,
                    ease: 'power2.out'
                }
            });
        });

        document.querySelectorAll('.horizontal-scrolling-text.desktop h2[data-gsap-scroll-left]').forEach((target) => {
            gsap.from(target, {
                x: 200,
                scrollTrigger: {
                    trigger: target,
                    start: 'top 685px',
                    end: 'bottom top',
                    markers: false,
                    pin: false,
                    pinSpacing: !isFirefox, // true if any browser than Firefox
                    scrub: 1,
                    ease: 'power2.out'
                }
            });
        });
    }
}